<script>
    import { onMount } from "svelte";
    import { DateInput } from "date-picker-svelte";
    import {Line} from "svelte-chartjs";
    import { Chart as ChartJS,Title,Tooltip,Legend,LineElement,LinearScale,PointElement,CategoryScale,} from 'chart.js';
    ChartJS.register(Title,Tooltip,Legend,LineElement,LinearScale,PointElement,CategoryScale);

    // 所有设备代码
    let totalcount = 0;
    let devcodes = [];

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

    var localeconf = {
        weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        months: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
        ],
    };

    let dataobj = {};
    let optnobj =  {
        scales: {
            y: { min: 0, max: 100 }
        }
    };

    let deviceopts = [];
    let nowDay = new Date();
    nowDay.setDate(nowDay.getDate() - 90);
    let frmStartDate = nowDay;
    let frmEndDate = new Date();
    let frmDevice = "";
    let frmDeviceSearch = "";
    let frmProperty = "lpos";
    
    // 加载事件函数
    onMount(() => {
        loadDevices();
    });

    function loadDevices() {
        let tmpUrl = "/rtapi/getdevlist";
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        devcodes = response.result;
                        totalcount = devcodes.length;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }

    function fixMax(inmax) {
        let outMax = 1;
        if  (inmax < 5) {
            outMax = 5;
        } else if (inmax < 10) {
            outMax = 10;
        } else if (inmax < 20) {
            outMax = 20;
        } else if (inmax < 50) {
            outMax = 50;
        } else if (inmax < 100) {
            outMax = 100;
        } else if (inmax < 150) {
            outMax = 150;
        } else if (inmax < 200) {
            outMax = 200;
        } else if (inmax < 300) {
            outMax = 300;
        } else if (inmax < 500) {
            outMax = 500;
        } else if (inmax < 1000) {
            outMax = 1000;
        } else {
            outMax = 2000;
            // outMax = (Math.ceil(inmax / 10) + 5) * 10;
        }
        return outMax;
    }

    function GenGraph() {
        let datax = [];
        let datay1 = [];
        let ymin = 0;
        let ymax = 100;
        let strStart = CommonLib.dtFormat("YYYY-mm-dd",frmStartDate);
        let strEnd = CommonLib.dtFormat("YYYY-mm-dd",frmEndDate);
        let tmpUrl = "/dbapi/queryhistorydata?devid="+frmDevice+"&property="+frmProperty+"&start="+strStart+"&end="+strEnd;
        //console.log(tmpUrl);
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        let hidatas = response.result;
                        //console.log(hidatas);
                        let tmpMax = 0;
                        for (let i=0;i<hidatas.length;i++) {
                            let tmp_date = new Date(hidatas[i].rdatatime);
                            let tmp_datestr = (tmp_date.getMonth() + 1).toString() + "-" + tmp_date.getDate().toString() + " " + tmp_date.getHours().toString();
                            datax.push(tmp_datestr);
                            if (tmpMax < hidatas[i].floatval) {
                                tmpMax = hidatas[i].floatval;
                            }
                            datay1.push(hidatas[i].floatval);
                        }
                        ymax = fixMax(tmpMax);
                        dataobj = {
                            labels: datax,
                            datasets: [
                                {
                                    label: frmProperty,
                                    backgroundColor: "rgb(255, 0, 0)",
                                    borderColor: "rgb(255, 0, 0)",
                                    data: datay1
                                }
                            ]
                        };
                        optnobj = {
                            scales: {
                                y: { min: ymin, max: ymax }
                            }
                        };
                    }
                } else {
                    toastr.error("调取历史数据错误:");
                }
            },
            error: function (err) {
                console.log(err);
                toastr.error("调取历史数据异常:");
            }
        })
    }

    function on_search_keyup(event) {
        if (event.keyCode == 13) {
            let tmpOpt = [];
            for (let i=0;i<devcodes.length;i++) {
                if (devcodes[i].includes(frmDeviceSearch)) {
                    tmpOpt.push(devcodes[i]);
                }
            }
            deviceopts = tmpOpt;
            if (deviceopts.length >0) {
                frmDevice = deviceopts[0];
            }
        }
    }

</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>历史数据查询</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- /Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title" style="width:1000px">
                                <form class="form-lrpadding">
                                    <div class="form-group row">
                                        <label for="frmStartDate" class="col-sm-2 col-form-label">指定时间:</label>
                                        <div class="col-sm-3">
                                            <DateInput
                                                id="frmStartDate"
                                                bind:value={frmStartDate}
                                                format="yyyy-MM-dd"
                                                locale={localeconf}
                                            />
                                        </div>
                                        <div class="col-sm-3">
                                            <DateInput
                                                id="frmEndDate"
                                                bind:value={frmEndDate}
                                                format="yyyy-MM-dd"
                                                locale={localeconf}
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="frmDevice" class="col-sm-2 col-form-label">选择设备:</label>
                                        <div class="col-sm-7">
                                            <select
                                                class="form-control"
                                                id="frmDevice"
                                                bind:value={frmDevice}
                                            >
                                                {#each deviceopts as opt}
                                                <option value={opt}>{opt}</option>
                                                {/each}
                                            </select>
                                        </div>
                                        <div class="col-sm-3">
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="frmDeviceSearch"
                                                bind:value={frmDeviceSearch}
                                                placeholder="输入关键字+回车"
                                                on:keyup={on_search_keyup}
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="frmProperty" class="col-sm-2 col-form-label">选择参数:</label>
                                        <div class="col-sm-4">
                                            <select
                                                class="form-control"
                                                id="frmProperty"
                                                bind:value={frmProperty}
                                            >
                                                <option value="lpos">液位</option>
                                                <option value="ch4">甲烷</option>
                                                <option value="h2s">硫化氢</option>
                                                <option value="co">一氧化碳</option>
                                                <option value="temperature">温度</option>
                                                <option value="humidity">湿度</option>
                                                <option value="batvol">电池电压</option>
                                                <option value="siglevel">信号强度</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </h4>
                            <div class="card-tools">
                                <button
                                    type="submit"
                                    class="btn btn-default"
                                    on:click={GenGraph}
                                >
                                    <i class="bi bi-calculator" /> 分析计算
                                </button>&nbsp;&nbsp;
                            </div>
                        </div>
                        <div class="card-body" style="padding-bottom: 20px;">
                            <!-- graph analysis -->
                            <Line data={dataobj} options={optnobj} style="height:500px;width:1500px" />
                            <!-- /graph analysis-->
                        </div>
                    </div>
                    <!-- /card -->
                </div>
            </div>
        </div>
    </section>
    <!-- /Main content -->

</div>
<style>
</style>
